import { CAPTCHA_ACTIONS, createCaptcha, useCaptcha } from '@percent/utility'
import { config } from '@percent/cause-dashboard/config'

const captcha = createCaptcha(() => config.keys.recaptchaSiteKey)

export const useLoginCaptcha = (enabled = true) => useCaptcha(captcha, CAPTCHA_ACTIONS.login, enabled)

export const useForgotPasswordCaptcha = () => useCaptcha(captcha, CAPTCHA_ACTIONS.forgotPassword, true)
